import React, { FunctionComponent, useEffect } from 'react';
import ErrorPage from 'app/components/pages/ErrorPage';
import IknowIcon from 'app/components/svgs/IknowIcon';
import H1 from 'app/components/common/H1';
import H2 from 'app/components/common/H2';
import { useClasses } from 'app/utils/css';
import { formatGenericError } from 'app/utils/errors';
import { useI18n } from 'app/components/localization';
import { notify } from 'app/services/errorReporter';

interface IProps {
  error?: Error;
}

export const UnknownError: FunctionComponent<IProps> = ({ error }) => {
  const { t } = useI18n();

  useEffect(() => {
    notify(error, { name: 'UnknownErrorPage' });
  }, [error]);

  const css = useClasses({
    contents: {
      display:        'flex',
      flexDirection:  'row',
      justifyContent: 'space-between',
    },
    owl: {
      flexGrow: 0,
      flexShrink: 2,
    },
    message: {
      flexShrink: 1,
    },
  });

  return (
    <ErrorPage status={500} title={t('page.error.title')}>
      <section>
        <header>
          <H1>{t('page.error.header')}</H1>
          <H2>{t('page.error.subheader')}</H2>
        </header>

        <div className={css.contents}>
          <div className={css.message}>
            <p>{t('page.error.message')}</p>

            {error && (
              <div data-testid="unknown-error-page">
                {t('page.error.error-message-label')}
                <pre>{formatGenericError(error)}</pre>

                {t('page.error.stack-trace-label')}
                <pre>{error && error.stack}</pre>
              </div>
            )}
          </div>

          <div className={css.owl}>
            <IknowIcon colorful />
          </div>
        </div>
      </section>
    </ErrorPage>
  );
};

export default UnknownError;
